import { render, staticRenderFns } from "./PublicationOpened01.vue?vue&type=template&id=4774abc3"
import script from "./PublicationOpened01.vue?vue&type=script&lang=js"
export * from "./PublicationOpened01.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports